import { useRouter } from "next/router";

const useIsCourseCatalog = (): boolean => {
  const router = useRouter();
  return router.pathname === "/marketplace/[id]";
};

export default useIsCourseCatalog;
